module.exports = __webpack_public_path__ + "img/Jump Casting82.82e235a9.jpg";